<app-modal-container [title]="title" [bigSize]="false" [buttons]="modalButtons" [spinnerProps]="spinnerProps"
  (closeButtonClicked)="closeModal.emit()"
  (applyButtonClicked)="confirm()" [applyActivated]="notificationForm.valid"
  (dismissButtonClicked)="closeModal.emit()">
  <form class="vertical-container column-gap-1" [formGroup]="notificationForm" >
    <div class="picker selector centered-column-container" [class.active]="showFundSelector" >

      <span class="input-title">Fund</span>
      <div class="control" (click)="showFundSelector=true">
        <span *ngIf="reminderFundName;else noFundName" class="font-3">{{fundFromReminder?.name}}</span>
        <ng-template #noFundName>
          <span  class="font-3">{{selectedFund?.name}}</span>
        </ng-template>

        <app-dropdown-icon class="suffix"></app-dropdown-icon>
      </div>
      <app-popup-modal
        *ngIf="showFundSelector"
        (closeModal)="showFundSelector=false">
      <div class="picker-dropdown width-unset centered-column-container" >
        <div class="autocomplete-input">
          <app-input data-qa="crud-notification-fund"
            [placeholder]="'Search fund...'"
            [input]="notificationForm.value.fundSearch" (inputChange)="filterOrgs($event)"
            [formControlName]="'fundSearch'">
          </app-input>
        </div>
        <app-cancel-button class="delete-input-icon icon-main-fill" (click)="resetFundSearch()"
          *ngIf="notificationForm.value.fundSearch">
        </app-cancel-button>
        <div class="picker-list centered-column-container">
          <div *ngFor="let org of filteredOrgsWithRole" class="centered-column-container list-block">
            <span class="list-subheader start-row-container flex-wrap row-gap-0p375 column-gap-0p25">
              <span>{{org.organization.name}}</span>
              <span class="title-admin" *ngIf="org.role==='admin'">Admin</span>
              <span class="title-admin" *ngIf="org.role==='externalAdmin'">Ext. admin</span>
            </span>
            <span class="list-entry sub-list" [class.selected]="fund === selectedFund"
              [appScrollIntoView]="fund === selectedFund" *ngFor="let fund of org.organization.funds"
              (click)="emitSelectedFund(fund)">{{fund.name}}</span>
          </div>
        </div>
      </div>
    </app-popup-modal>
    </div>
    <div class="space-between-horizontal-centered row-gap-1p25">

    <app-input
      data-qa="crud-notification-reminder-date"
      [dateInput]="true"
      [required]="true"
      [formControlName]="'reminderDate'"
      [title]="'Reminder date'" class="width-20"
      [input]="body.reminderDate"
      [inputID]="'reminder'"
      [maxDate]="notificationForm.value.deadline">
    </app-input>
    <app-input
      data-qa="crud-notification-reminder-dead-line"
      [dateInput]="true"
      [required]="true"
      [formControlName]="'deadline'"
      [title]="'Deadline date'"
      [input]="body.deadline" class="width-20"
      [inputID]="'deadline'"
      [minDate]="notificationForm.value.reminderDate">
    </app-input>
  </div>
    <app-selector
      data-qa="crud-notification-reminder-topic"
      [isNotInTable]="true"
      [data]="topics"
      [selectedItem]="body.topic"
      [isRequired]="true"
      [title]="'Topic'"
      (itemEmitter)="notificationForm.patchValue({topic: $event})">
    </app-selector>
    <app-input
      data-qa="crud-notification-reminder-description"
      class="textarea-height-6p5"
      [textArea]="true"
      [formControlName]="'description'"
      [title]="'Description'"
      [input]="body.description">
    </app-input>
    <div class="start-row-container">
      <app-checkbox
        data-qa="crud-notification-reminder-personal"
        [formControlName]="'isPersonal'"
        [checked]="body.isPersonal">
      </app-checkbox>
      <div class="start-column-container">
        <span class="font-4 bold500">Personal</span>
        <span class="caption-2 opacity0p64">Do not share this reminder with other members</span>
      </div>
    </div>
  </form>
</app-modal-container>
